import { useFeatureAccess } from './platformAccess';
import TuneIcon from '@mui/icons-material/Tune';
import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import DateTimePreferences, { DateTimePreferenceFields } from './DateTimePreferences';
export default function DateTimePreferencesLink({ prefs, timezone, onTimezoneSelect } = {}) {
  const [open, setOpen] = useState(false);
  const { ethiopianEnabled } = useFeatureAccess();
  if (!ethiopianEnabled) return null;
  return <>
    <Button size="small" startIcon={<TuneIcon />} aria-label="Date & time preferences" onClick={() => setOpen(true)} sx={{ textTransform: 'none', alignSelf: 'flex-start', color: 'text.secondary' }}>Date &amp; time</Button>
    <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
      <DialogTitle>Date &amp; time preferences</DialogTitle>
      <DialogContent>{prefs ? <DateTimePreferenceFields prefs={prefs} timezone={timezone} onTimezoneSelect={onTimezoneSelect} /> : <DateTimePreferences timezone={timezone} />}</DialogContent>
      <DialogActions><Button onClick={() => setOpen(false)}>Done</Button></DialogActions>
    </Dialog>
  </>;
}
